import { useState } from "react";

import { MarkCompleteConfirmDialog } from "./MarkCompleteConfirmDialog";

export interface SegmentationStudyNavigation {
  hasPrevious: boolean;
  hasNext: boolean;
  isComplete: boolean;
  isMarkingComplete: boolean;
  onPrevious: () => void;
  onNext: () => void;
  onMarkComplete: () => void;
}

export function SegmentationStudyFooter({
  navigation,
  annotationActive,
  confirmComplete = false,
}: {
  navigation: SegmentationStudyNavigation;
  annotationActive: boolean;
  /** Ask for confirmation before Mark Complete (segmentation study only). */
  confirmComplete?: boolean;
}) {
  const [confirmOpen, setConfirmOpen] = useState(false);
  return (
    <div className="grid grid-cols-3 gap-2 px-3 pb-3 pt-2 border-t border-border-strong shrink-0">
      <button
        type="button"
        onClick={navigation.onPrevious}
        disabled={!navigation.hasPrevious}
        className="sidebar-btn h-9 text-[11px] disabled:opacity-40"
      >
        ← Prev
      </button>
      <button
        type="button"
        onClick={confirmComplete ? () => setConfirmOpen(true) : navigation.onMarkComplete}
        disabled={navigation.isComplete || navigation.isMarkingComplete || annotationActive}
        className="sidebar-btn-primary h-9 text-[11px] disabled:opacity-40 disabled:cursor-not-allowed"
        title={
          annotationActive
            ? "Save or cancel the active annotation first"
            : "Mark this case complete"
        }
      >
        {navigation.isMarkingComplete
          ? "Marking…"
          : navigation.isComplete
            ? "Complete"
            : "Mark Complete"}
      </button>
      <button
        type="button"
        onClick={navigation.onNext}
        disabled={!navigation.hasNext}
        className="sidebar-btn h-9 text-[11px] disabled:opacity-40"
      >
        Next →
      </button>
      {confirmComplete && (
        <MarkCompleteConfirmDialog
          open={confirmOpen}
          onOpenChange={setConfirmOpen}
          onConfirm={navigation.onMarkComplete}
        />
      )}
    </div>
  );
}
